import * as THREE from '@phdsoft/three';
import { Region } from '../../platform/busines-data/Framework/Region';

/** Maximum number of ancestors walked when resolving a mesh to its region/section. */
const MAX_ANCESTOR_DEPTH = 8;

/**
 * Walks up the parent chain of `obj` and returns the Guids of the first
 * candidate region (and section, when the match is a section group) whose
 * THREE group is an ancestor.
 *
 * `candidateRegions` must include every campaign whose meshes can be picked:
 * the structure regions AND, for light-model assets, the light-model regions
 * (their meshes are parented straight under `region.group`). Light-model
 * regions share Guids with the structure regions but own distinct groups.
 */
export function resolveRegionAndSectionIds(
    obj: THREE.Object3D,
    candidateRegions: ReadonlyArray<Region>,
): { regionId: string | null; sectionId: string | null } {
    let current = obj.parent;
    let depth = 0;
    while (current && depth < MAX_ANCESTOR_DEPTH) {
        for (const region of candidateRegions) {
            const section = region?.sections?.find(s => s.group === current);
            if (section) {
                return { regionId: region.Guid, sectionId: section.Guid };
            }
            if (region?.group === current) {
                return { regionId: region.Guid, sectionId: null };
            }
        }
        current = current.parent;
        depth++;
    }
    return { regionId: null, sectionId: null };
}
